import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import LedgersRepository from "../../Repository/LedgersRepository";

const initialState = {
  loading: false,
  error: "",
  ledgers: [],
  salesTotal: 0,
  purchasesTotal: 0,
  type: "",
  selected: {},
  token: "",
  hasMore: true,
  filtered: [],
};
export const getLedgers = createAsyncThunk(
  "ledgers/fetchLedgers",
  async (props) => {
    try {
      const response = await LedgersRepository.ledgerModel({
        request: {
          method: "getLedgersByCompany",
          data: {
            company_code: localStorage.getItem("companyCode"),
            ...props,
          },
        },
      });

      console.log("API Response Data:", response.data.response.data);
      return response.data.response.data;
    } catch (err) {
      console.error("API Error:", err);
      throw err; // Ensure Redux handles the error properly
    }
  }
);

export const ledgerSlice = createSlice({
  name: "ledgers",
  initialState,

  reducers: {
    selectedLedger: (state, action) => {
      const { selectedLedger } = action.payload;
      state.selected = selectLedger;
    },
    selectLedger: (state, action) => {
      const { type, ledger } = action.payload;
      state.selected = ledger;
      state.type = type;
    },
    entryUpdated: (state, action) => {
      state.selected = action.payload;
    },
    entryAdded: (state, action) => {
      const { type, entry } = action.payload;
      if (state.selected[type]) {
        state.selected[type] = [entry, ...state.selected[type]];
      } else {
        state.selected[type] = [];
        state.selected[type] = [entry];
      }
    },
    entryRemove: (state, action) => {
      const { type, entry } = action.payload;
      let found = state.selected[type].findIndex(
        (item) => item.srNum == entry.srNum
      );
      state.selected[type].splice(found, 1);
    },

    ledgerAdded: (state, action) => {
      const { index, ledger } = action.payload;
      state.ledgers.splice(index, 0, ledger);
    },
    ledgerRemove: (state, action) => {
      let { index } = action.payload;
      state.ledgers.splice(index, 1);
    },
    ledgerTypeUpdate: (state, action) => {
      const { index, type } = action.payload;
      state.ledgers[index].ledgerType = type;
    },
    ledgerUpdated: (state, action) => {
      const { index, ledger } = action.payload;
      if (index == "id") {
        let found = state.ledgers.find((i) => i._id == ledger._id);
        if (found) {
          found.name = ledger.name;
          found.address = ledger.address;
          found.region = ledger.region;
        }
      } else if (index == "searched") {
      } else {
        state.ledgers[index].name = ledger.name;
        state.ledgers[index].address = ledger.address;
        state.ledgers[index].region = ledger.region;
      }
    },
    amountAdded: (state, action) => {
      const { _id, amount, key } = action.payload;
      let found = state.ledgers.find((item) => item._id == _id);
      if (found) {
        let type = found[key];
        if (type) {
          found[key] = parseInt(found[key]) + parseInt(amount);
        } else {
          found[key] = parseInt(amount);
        }
      }
    },
    amountRemove: (state, action) => {
      const { _id, amount, key } = action.payload;
      let found = state.ledgers.find((item) => item._id == _id);
      found[key] = parseInt(found[key] - amount);
    },
    ledgerTotalAdded: (state, action) => {
      const { amount, key } = action.payload;
      if (key == "purchaseTotal") {
        state.purchasesTotal = parseInt(state.purchasesTotal + amount);
      } else if (key == "saleTotal") {
        state.salesTotal = parseInt(state.salesTotal + amount);
      }
    },
    ledgerTotalRemove: (state, action) => {
      const { amount, key } = action.payload;
      if (key == "purchaseTotal") {
        state.purchasesTotal = parseInt(state.purchasesTotal - amount);
      } else if (key == "saleTotal") {
        state.salesTotal = parseInt(state.salesTotal - amount);
      }
    },
    clearLedgers: (state) => {
      state.ledgers = [];
      state.hasMore = true;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getLedgers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getLedgers.fulfilled, (state, action) => {
      console.log("action.payloaddd",action.payload )
      const {
        ledgers,
        salesTotal,
        current_page_token,
        purchasesTotal,
        next_page_token,
      } = action.payload;
      console.log("ledgerssssssssss", ledgers);
      let more = true;
      if (ledgers.length < 20) {
        more = false;
      } else if (current_page_token != "" && next_page_token == "") {
        more = false;
      }

      state.loading = false;
       state.ledgers = [ ...ledgers];
      // state.ledgers = ledgers;

      state.salesTotal = salesTotal;
      state.purchasesTotal = purchasesTotal;
      state.token = next_page_token;
      state.error = "";
      state.hasMore = more;
    });

    builder.addCase(getLedgers.rejected, (state, action) => {
      state.loading = false;
      state.ledgers = [];
      state.error = action.error.message;
    });
  },
});

export const {
  ledgerRemove,
  ledgerAdded,
  ledgerUpdated,
  amountAdded,
  amountRemove,
  clearLedgers,
  ledgerTypeUpdate,
  ledgerTotalAdded,
  ledgerTotalRemove,
  selectLedger,
  entryAdded,
  entryRemove,
  entryUpdated,
  selectedLedger,
} = ledgerSlice.actions;

export default ledgerSlice.reducer;
